import { updateTokenInStore } from './tokenRefresher';
import { store } from '../store';

const MAX_ATTEMPTS = 3;
const RETRY_DELAY_MS = 600;

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Performs a single attempt to exchange the legacy token for an SMX5 access token.
 * Returns true only when the access token was successfully received AND persisted.
 */
const attemptSmx3Access = async (token: string | null): Promise<boolean> => {
    const port = process.env.REACT_APP_API_PORT ? `:${process.env.REACT_APP_API_PORT}` : '';
    const smx3TokenUrl = `${window.location.protocol}//${window.location.hostname}${port}/api/v1/auth/smx3`;

    const smx3AccessResponse = await fetch(smx3TokenUrl, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
    });

    if (!smx3AccessResponse.ok) {
        return false;
    }

    const accessData = await smx3AccessResponse.json();
    if (!accessData?.data) {
        return false;
    }

    // Only report success once the token is actually decodable and stored.
    return updateTokenInStore(store, accessData.data);
};

export const smx3AccessTokenSetter = async (searchParams: URLSearchParams): Promise<boolean> => {
    const token = searchParams.get('token');

    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
        try {
            const isSet = await attemptSmx3Access(token);
            if (isSet) {
                return true;
            }
        } catch (error) {
            console.error(`smx3 access attempt ${attempt} failed`, error);
        }

        if (attempt < MAX_ATTEMPTS) {
            await delay(RETRY_DELAY_MS);
        }
    }

    return false;
};
